import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import Link from '../../../../../components/ZUILib/Link';
import RadioButton from '../../../../../components/ZUILib/RadioButton';
import Monedero from './monedero';
import UserCard from './UserCardBankCreate';
import TarjetaLiverpool from './TarjetaLiverpool';
import Combinado from './Combinado';
import ClosingGift from './ClosingGift';
import InputButton from '../../../../../components/ZUILib/InputButton';
import commonUtil from '../../../../../utils/commonUtil';

const channel = commonUtil.getChannel();
const constChannels = commonUtil.getClientConstForChannel();
const applicationRoutes = commonUtil.getApplicationRoutes();

export default class DepositForm extends Component {
  constructor(props) {
    super(props);

    this.allTransferOptions = [
      { id: 0, label: 'Monedero' },
      { id: 1, label: 'Tarjeta Liverpool' },
      { id: 2, label: 'Cuenta bancaria o tarjeta Liverpool' },
      { id: 3, label: 'Cuenta bancaria o tarjeta Liverpool Premium Card' },
      { id: 4, label: 'Combinado' },
      { id: 5, label: 'Monedero Mesa de regalos' },
    ];

    this.state = {
      transferenceMethods: [],
      availableCardsInfo: null,
      isMonedero: false,
      isBankCard: false,
      isEmployee: false,
      isCombinado: false,
      isContinueButtonDisable: true,
      walletLengthError: false,
      selectedTransferenceMethodsCode: '',
    };

    this.isClosingGiftEligible = false;
  }

  UNSAFE_componentWillMount() {
    const transferenceMethods = [];
    if (this.props.transference && this.props.transference.transferenceOptions
      && this.props.transference.transferenceOptions.transferenceMethods) {
      this.props.transference.transferenceOptions.transferenceMethods.forEach((option) => {
        if (option.code === '1') {
          if (this.props.transference.employeeCardInfo && this.props.transference.employeeCardInfo.length > 0) {
            transferenceMethods.push({ name: option.name, code: option.code });
          }
        } else {
          transferenceMethods.push({ name: option.name, code: option.code });
        }
      });
      this.setState({
        transferenceMethods,
        availableCardsInfo: this.props.transference.transferenceOptions.availableCardsInfo,
        selectedTransferenceMethodsCode: transferenceMethods.length === 1 ? transferenceMethods[0].code : '',
      });
      if (transferenceMethods.length === 1) {
        this.loadComponentByCode(transferenceMethods[0].code);
      }

      // if (this.props.transference.isClosingGiftEligible &&
      //   this.props.transference.isClosingGiftEligible.toString() === 'true') {
      //   this.isClosingGiftEligible = true;
      // }

      // if(this.props.userEventThresholdGiftDetails?.data?.giftInfo) {
      //   this.isClosingGiftEligible = true;        
      // }

      if (this.props.transference.transferenceOptions.transferableAmount <= 0 &&
        this.props.transference.transferenceOptions.bonusAmount <= 0 &&
        this.isClosingGiftEligible) {
        this.disableContinueButton(false);
      }
    }
  }

  handleRadioSelected = (data, e) => {
    this.setState({ selectedTransferenceMethodsCode: e.target.value });
    this.loadComponentByCode(e.target.value);
  }

  loadComponentByCode = (code) => {
    if (code === '0') {
      this.setState({ isMonedero: true, isBankCard: false, isCombinado: false, isEmployee: false, isContinueButtonDisable: true });
    } else if (code === '1') {
      this.setState({ isMonedero: false, isBankCard: false, isCombinado: false, isEmployee: true, isContinueButtonDisable: true });
    } else if (code === '2' || code === '3') {
      this.setState({ isMonedero: false, isBankCard: true, isCombinado: false, isEmployee: false, isContinueButtonDisable: true });
    } else if (code === '4') {
      this.setState({ isMonedero: false, isBankCard: false, isCombinado: true, isEmployee: false, isContinueButtonDisable: false });
    } else if (code === '6') {  // type : refund
      this.setState({ isContinueButtonDisable: false });
    }
  }

  disableContinueButton = (isDisable) => {
    this.setState({ isContinueButtonDisable: isDisable });
  }

  walletLengthError = (isWalletLengthErro) => {
    this.setState({ walletLengthError: isWalletLengthErro });
    if (channel === constChannels.WAP) {
      commonUtil.goToTop();
    }
  }

  onNextStepClick = () => {
    let submitTransferenceObj = null;
    this.props.submitTransferenceDataFunction(null);
    let walletLengthError = false;
    if (this.state.isMonedero) {
      if ((this.monedero.state.walletNumber_mltpc && this.monedero.state.walletNumber_mltpc.length > 0 && this.monedero.state.walletNumber_mltpc && this.monedero.state.walletNumber_mltpc.length < 16)
      || (this.monedero.state.walletNumber_mmdr && this.monedero.state.walletNumber_mmdr.length > 0 && this.monedero.state.walletNumber_mmdr && this.monedero.state.walletNumber_mmdr.length < 13)) {
        this.walletLengthError(true);
        walletLengthError = true;
      } else {
        this.walletLengthError(false);
        walletLengthError = false;
        submitTransferenceObj = this.monedero.getFormData();
        if (this.isClosingGiftEligible) {
          submitTransferenceObj = {
            ...submitTransferenceObj,
            // ...this.closingGift.getFormData(),
          };
        }
        this.props.submitTransferenceDataFunction(submitTransferenceObj);
      }
    } else if (this.state.isBankCard) {
      submitTransferenceObj = this.userCard.getFormData();
      this.props.submitTransferenceDataFunction(submitTransferenceObj);
    } else if (this.state.isEmployee) {
      submitTransferenceObj = this.tarjeta.getFormData();
      if (this.isClosingGiftEligible) {
        submitTransferenceObj = {
          ...submitTransferenceObj,
          // ...this.closingGift.getFormData(),
        };
      }
      this.props.submitTransferenceDataFunction(submitTransferenceObj);
    } else if (this.state.isCombinado) {
      submitTransferenceObj = this.combinado.getFormData();
      this.props.submitTransferenceDataFunction(submitTransferenceObj);
    } else if (this.isClosingGiftEligible) {
      submitTransferenceObj = {
        // ...this.closingGift.getFormData(),
        totalAmount: '0', // Service call field is mandatory
        walletType: 'Closing Gift',
        paymentMode: 'ClosingGift',
      };
      this.props.submitTransferenceDataFunction(submitTransferenceObj);
    }
    if (!walletLengthError) this.props.nextPage(2);
  }

  rediectToPage = () => {
    this.props.setGiftListTransferenceStatementTab(true);
    browserHistory.push(commonUtil.routeTo(applicationRoutes.giftList, { eventID: this.props.eventId }));
  }

  render() {
    const monederoComponent = this.state.isMonedero &&
      <Monedero
        ref={monedero => (this.monedero = monedero)}
        user={this.props.user}
        transferenceData={this.props.transference}
        disableContinueButton={this.disableContinueButton}
        lables={this.props.lables} eventId={this.props.eventId}
      />;

    const cardBankComponent = this.state.isBankCard &&
      <UserCard
        ref={userCard => (this.userCard = userCard)}
        transferenceData={this.props.transference}
        disableContinueButton={this.disableContinueButton}
        lables={this.props.lables}
      />;

    const employeeComponent = this.state.isEmployee &&
      <TarjetaLiverpool
        ref={tarjeta => (this.tarjeta = tarjeta)}
        transferenceData={this.props.transference}
        disableContinueButton={this.disableContinueButton}
        eventId={this.props.eventId} lables={this.props.lables}
      />;

    const combinadoComponent = this.state.isCombinado &&
      <Combinado
        ref={combinado => (this.combinado = combinado)}
        transferenceData={this.props.transference}
        disableContinueButton={this.disableContinueButton}
        lables={this.props.lables}
      />;

    const nextStep = {
      name: 'Siguiente',
      type: 'button',
      value: 'Siguiente',
      autoFocus: false,
      style: 'btnPrimary size-Large',
      onClickHandler: this.onNextStepClick,
      id: 'nextStep',
      iconClass: 'iconRight icon-flecha_lightsvg_derecha',
      disabled: this.state.isContinueButtonDisable ? 'disabled' : '',
    };

    const cancelButton = {
      name: 'Cancelar',
      type: 'button',
      value: 'Cancelar',
      autoFocus: false,
      style: 'btnSecondary size-Large',
      cssStyle: {
        borderRadius: '4px',
      },
      onClickHandler: this.rediectToPage,
    };

    const nextStepLink = {
      id: 'nextStepLink',
      text: 'Siguiente',
      children: 'Siguiente paso',
      href: '',
      cssStyle: {
        borderRadius: '4px',
      },
      cssClass: this.state.isContinueButtonDisable ? 'btnPrimary size-Full hiddenStyle' : 'btnPrimary size-Full',
      onClickHandler: this.onNextStepClick,
    };

    const errorAncher = {
      cssClass: 'icon-tache2',
      onClickHandler: () => { this.setState({ walletLengthError: null }); },
    };

    const fullContainer = {
      width: channel === constChannels.WEB ? '93%' : null,
      margin: channel === constChannels.WEB ? '4%' : null,
    };

    const alerContainerWeb = {
      border: '1px solid #ADA8A8',
      borderRadius: '20px',
    };

    return (
      <div style={fullContainer}>
        {channel === constChannels.WAP ?
          <React.Fragment>
            <div className="col-xs-12 inneroptions"><p className="text-red text-right">* Campos obligatorios</p></div>
            <div className="col-xs-12 innerOptions">
              <p style={{ fontSize: '24px', color: '#333333', fontWeight: '400' }}>
                {commonUtil.getLabel(this.props.lables['Retiro Anticipado Landing Page'], 'eventTransferences.label1')}
              </p>
              {this.state.walletLengthError ?
                <div className="alertError">
                  <i className="icon-tache2" />
                  <p>{commonUtil.getLabel(this.props.lables['Retiro Anticipado Landing Page'], 'eventTransferences.ewalletInvalid.message')}</p>
                  <Link linkJSON={errorAncher} />
                </div>
                : null}

            </div>
            {this.state.transferenceMethods.length ? /* eslint-disable */
              <div>
                <div class="col-xs-12 innerOptions">
                  <div>
                    <p style={{fontSize: '16px', color: '#333333', fontWeight: '400'}}>
                      Selecciona forma de depósito
                    </p>
                  </div>
                </div>
                {this.state.transferenceMethods.map((option, index) => (
                  option.code === "1" 
                  ? employeeComponent
                  :
                  <div className="col-xs-12 innerOptions">
                    <RadioButton
                      checked={this.state.selectedTransferenceMethodsCode === option.code}
                      key={index} displayName={option.name}
                      id={'radio_transferenceMethods_' + option.code}
                      value={option.code}
                      name="transferenceMethods"
                      title={option.name}
                      radioCssClass={'radio radioDF'}
                      onChangeFunction={this.handleRadioSelected}
                      innerContent={option.code === '0' ? <i className="iClass icon-ayuda display-inline-block tooltip-container text-pink">
                        <span className="tooltip-box">{commonUtil.getLabel(this.props.lables['Estado de Cuenta Page'], 'eventClosure.monedero.clousre.tooltip')}</span>
                      </i> : null}
                    >
                      {option.code === '0' ? monederoComponent :
                          option.code === '2' || option.code === '3' ? cardBankComponent :
                            option.code === '4' ? combinadoComponent : null}
                    </RadioButton>
                  </div>
                ))}
              </div>/* eslint-enable */ : null}

            {/* {this.isClosingGiftEligible ?
              <div className="col-xs-12 innerOptions">
                <ClosingGift ref={closingGift => (this.closingGift = closingGift)} lables={this.props.lables} eventId={this.props.eventId} userEventThresholdGiftDetails={this.props.userEventThresholdGiftDetails} /> </div> : null} */}

            <div className="col-xs-12 innerButtons">
              <Link linkJSON={nextStepLink}>Siguiente<i className="iconRight icon-flecha_lightsvg_derecha" aria-hidden="true" data-original-title title /></Link>
            </div>
          </React.Fragment>
          :
          <React.Fragment>
            <div className="panel" style={alerContainerWeb}>
              { this.props.transference && this.props.transference.transferenceOptions
              && this.props.transference.transferenceOptions.transferableAmount &&
              parseFloat(this.props.transference.transferenceOptions.transferableAmount) > 0
              ?
                <h3 style={{ marginLeft: '20px', paddingTop: '4%' }}>Forma de depósito</h3>
              : null
            }
              <div className="panel-heading row">
                <div className="col-xs-8">
                  {this.state.walletLengthError ?
                    <div className="alertError">
                      <i className="icon-tache2" />
                      <p>{commonUtil.getLabel(this.props.lables['Retiro Anticipado Landing Page'], 'eventTransferences.ewalletInvalid.message')}</p>
                      <Link linkJSON={errorAncher} />
                    </div>
                  : null}
                </div>
                <div className="col-xs-4 errorMessage">
                  <span className="text-red" style={{ paddingRight: '5px' }}>
                  * Campos obligatorios
                </span>
                </div>
              </div>
              <div className="panel-collapse collapse in" id="step1" aria-expanded="true" style={{}}>
                <div className="panel-body row">
                  {this.state.transferenceMethods.length >= 1 ?
                  /* eslint-disable */
                  <div className="col-xs-12 depositForm" style={{ paddingLeft: '20px' }}>
                    <span className="subtitleModule">Selecciona la forma de depósito</span>
                    {this.state.transferenceMethods.map((option, index) => (
                      option.code === "1" 
                      ? employeeComponent
                      :
                      <RadioButton
                        checked={this.state.selectedTransferenceMethodsCode === option.code}
                        key={index}
                        displayName={option.name}
                        id={'radio_transferenceMethods_' + option.code}
                        value={option.code}
                        name="transferenceMethods"
                        title={option.name}
                        radioCssClass={'radio radioDF'}
                        onChangeFunction={this.handleRadioSelected}
                        innerContent={option.code === '0' ? 
                        <span> 
                          <i className="iClass icon-ayuda display-inline-block tooltip-container text-pink">
                            <span 
                            className={`tooltip-box tooltipBox344  tooltipIcon344`}
                            >
                              <p style={{fontSize: '16px', fontWeight: 500, padding: '0 2%'}}>
                                  Transferencia a monedero
                              </p>
                              <p style={{padding: '0 2%'}}> 
                              {commonUtil.getLabel(this.props.lables['Estado de Cuenta Page'], 'eventClosure.monedero.clousre.tooltip')}
                              </p>
                           </span>
                          </i>  
                        </span> : null}
                      >
                        {option.code === '0' ? monederoComponent :
                            option.code === '2' || option.code === '3' ? cardBankComponent :
                              option.code === '4' ? combinadoComponent : null}
                      </RadioButton>
                    ))}
                  </div>
                  /* eslint-enable */
                  : null}
                  {/* {this.isClosingGiftEligible ?
                    <div className="col-xs-12 depositForm">
                      {this.state.transferenceMethods.length ? <hr /> : null}
                      <ClosingGift ref={closingGift => (this.closingGift = closingGift)} lables={this.props.lables} eventId={this.props.eventId} userEventThresholdGiftDetails={this.props.userEventThresholdGiftDetails} /> </div> : null} */}
                </div>
              </div>
            </div>
            <div className="col-xs-12" style={{ padding: 0 }}>
              <div className="innerButtons">
                <div className="col-sm-6 col-md-6">
                  <InputButton buttonAttr={cancelButton} />
                </div>
                <div className="col-sm-6 col-md-6" >
                  <InputButton buttonAttr={nextStep} />
                </div>
              </div>
            </div>
          </React.Fragment>

        }
      </div>

    );
  }
}
